import { guid } from '../../Config/Helpers';

export class DeviceSection {
    constructor(sectionName, rows, root = []) {
        this.sectionName = sectionName;
        this.rows = rows;
        this.uid = guid();
        this.root = root;
    }
}
